exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".time-label{\n    font-weight: bold;\n}\n\n.search {\n    margin-left: 180px;\n}", "", {"version":3,"sources":["/home/dev/bitool-new/client/app/main/reports/brand-pricing-analysis/brand-pricing.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;CACrB;;AAED;IACI,mBAAmB;CACtB","file":"brand-pricing.css","sourcesContent":[".time-label{\n    font-weight: bold;\n}\n\n.search {\n    margin-left: 180px;\n}"],"sourceRoot":""}]);

// exports
